import { useDropzone } from "react-dropzone";
import { Controller } from "react-hook-form";
import { LABELS } from "~/resources/Labels";
import { FormScriptResponse } from "~/models/Commons ";
import { UseFormScript } from "./UseFormScript";
import { SIMPLInput } from "../../components/commons/input/SIMPLInput";
import { SIMPLDialog } from "../../../src/components/commons/dialog/SimplDialog";
import { SIMPLSelectDropdown } from "../../components/commons/input/SIMPLSelectDropdown";
import { SIMPLCheckBox } from "../../components/commons/input/SIMPLCheckBox";
import { SIMPLButtonCustomized } from "../../components/commons/button/SIMPLButtonCustumized";
import SIMPLFile from "../../components/commons/input/SIMPLFile";
import { useEffect, useState } from "react";
import { extractEnvDetails, extractScriptTypeDetails } from "~/Utils/Utils";
import { LoadingWrapper } from "../../components/commons/spiner/SimpleLoaderWrapper";
import { useTranslation } from "react-i18next";
import { useGetOutputTemplatesQuery } from "~/services/outputTemplate";

 interface PropScript {
  onCloseModal: () => void;
  editedItem: FormScriptResponse | null;
  setConfig: Function;
  title?: string;
  refetch: () => void;
  onSuccess?: (title: string, message: string, response: any) => void;
  onError?: (title: string, message: string) => void;
}

const AddScript = ({
  onCloseModal,
  editedItem,
  setConfig,
  refetch,
  title,
  onSuccess,
  onError, 
}: PropScript) => {
  const {
    handleSubmit,
    control,
    errors,
    onScriptDrop,
    onConfigDrop,
    submitForm,
    cloudEnvData,
    scriptTypesData,
    isLoading,
    isError,
    refetchScriptTypes,
    watch,
    setValue,
  } = UseFormScript(editedItem, onCloseModal, refetch, onSuccess, onError);
  const [selectCloudEnv, setSelectCloudEnv] = useState<any[]>([]);
  const [selectScriptType, setSelectScriptType] = useState<any[]>([]);
  const { t } = useTranslation();

  const { data: outputTemplatesData } = useGetOutputTemplatesQuery({ page: 0, size: 9999, active: true });

  const watchedScriptTypeId = watch('scriptTypeId');

  const filteredOutputTemplates = (outputTemplatesData?.payload?.content ?? []).filter(
    (ot: any) => watchedScriptTypeId && ot.scriptType?.id === watchedScriptTypeId?.value
  );
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: onScriptDrop,
    maxFiles: 1,
    accept: {
      "application/x-yaml": [".yml", ".yaml"],
      "application/json": [".json"],
      "text/plain": [".hcl", ".tf"],
    },
  });

  const {
    getRootProps: getConfigRootProps,
    getInputProps: getConfigInputProps,
    isDragActive: isConfigDragActive,
  } = useDropzone({
    onDrop: onConfigDrop,
    maxFiles: 1,
    accept: {
      "application/x-yaml": [".yml", ".yaml"],
    },
  });

  const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    handleSubmit(submitForm)(event);
    setConfig({
      key: "",
      direction: LABELS.ASC,
    });
  };

  const scriptTypesOptions =() => {
    const payloadScriptTypes: any = scriptTypesData?.payload;
    if(scriptTypesData){
      setSelectScriptType(extractScriptTypeDetails(payloadScriptTypes.content));
    }
    
  };  
  const initVmTemplate = () => {
    const payloadEnviroment: any = cloudEnvData?.payload;
    if (payloadEnviroment) {
      setSelectCloudEnv(extractEnvDetails(payloadEnviroment.content));
    }
  };
  useEffect(() => {
    initVmTemplate();
    scriptTypesOptions();
  }, [cloudEnvData, scriptTypesData,refetchScriptTypes]);


  const renderButtons = () => (
    <>
      {!isLoading && (
        <div className="grow-0 basis-32 mr-5">
          <SIMPLButtonCustomized
            label={t('Cancel')}
            secondary
            buttonHandlerAction={onCloseModal}
            testId="script-button-cancel"
          />
        </div>
      )}
      {!isLoading && (
        <div className="grow-0 basis-32">
          <SIMPLButtonCustomized
            label={t(editedItem ? 'Update' : 'Submit')}
            primary
            testId="script-button-submit"
          />
        </div>
      )}
    </>
  );

  return (
    <SIMPLDialog
      onCloseModal={onCloseModal}
      title={t(title!)}
      actions={renderButtons()}
      onSubmit={handleFormSubmit}
      showLine
    >
      <LoadingWrapper
        loadingTitle={t('LoadingScripts')}
        isLoading={isLoading}
        isError={isError}
        testId="loading-script"
      >
        <div className="flex justify-center">
          <div className="w-[500px]">
            <div className="flex flex-col w-full space-y-4">
              <SIMPLInput
                name="title"
                control={control}
                rules={{
                  required: {
                    value: true,
                   
                  },
                }}
                messageRequired={t('MessageTitleRequired')}
                label={t('Title')}
                placeholder={t('Title')}
                required
                id="title"
                testId="script-title"
                fontWeight="bold"
                errorLabel={errors.title?.message}
              />

              <SIMPLInput
                name="description"
                control={control}
                rules={{
                  required: {
                    value: true
                  },
                }}
                messageRequired={t('MessagesDescriptionRequired')}
                label={t('Description')}
                required
                id="description"
                testId="script-description"
                fontWeight="bold"
                errorLabel={errors.description?.message}
                placeholder={t('Description')}
              />

              <Controller
                name="cloudEnvironmentId"
                control={control}
                rules={{ required: t('MessageCloudEnvironmentRequired') }}
                render={({ field }) => (
                  <SIMPLSelectDropdown
                    id="cloudEnvironmentId"
                    label={t('CloudEnvironment')}
                    options={selectCloudEnv?.map((cloudEnv: any) => ({
                      label: cloudEnv.environmentName,
                      value: cloudEnv.id,
                    }))}
                    isRequired
                    value={field.value}
                    onChange={field.onChange}
                    hideErrorLabel={false}
                    errorLabel={errors.cloudEnvironmentId?.message as string}
                    placeholder={t('CloudEnvironment')}
                    background="white"
                    testId="script-cloud-environment"
                  />
                )}
              />
               <Controller
                name="scriptTypeId"
                control={control}
                  rules={{ required: t('MessageScriptTypeRequired') }}
                  render={({ field }) => (
                  <SIMPLSelectDropdown
                    id="scriptTypeId"
                    label={t('Type')}
                     options={selectScriptType.map((scriptType: any) => ({
                      label: scriptType.name,
                      value: scriptType.id, 
                    }))}
                    isRequired
                    value={field.value}
                   onChange={field.onChange}
                    hideErrorLabel={false}
                    errorLabel={errors.scriptTypeId?.message as string}
                    placeholder={t('Type')}
                    background="white"
                    testId="script-script-type"
                  />
                )}
              />
               <Controller
                 name="outputTemplateId"
                 control={control}
                 rules={{ required: t('MessageOutputTemplateRequired') }}
                 render={({ field }) => {
                   const otOptions = filteredOutputTemplates.map((ot: any) => ({
                     label: ot.name,
                     value: ot.id,
                   }));
                   const isValueValid = field.value
                     ? otOptions.some((opt: any) => opt.value === field.value?.value)
                     : false;
                   return (
                     <SIMPLSelectDropdown
                       id="outputTemplateId"
                       label={t('OutputTemplate')}
                       options={otOptions}
                       isRequired
                       value={isValueValid ? field.value : null}
                       onChange={field.onChange}
                       hideErrorLabel={false}
                       errorLabel={errors.outputTemplateId?.message as string}
                       placeholder={t('OutputTemplate')}
                       background="white"
                       testId="output-template"
                     />
                   );
                 }}
                />
               <Controller
                 name="manual"
                 control={control}
                 render={({ field }) => (
                   <SIMPLCheckBox
                     id="manual"
                     label={t('Manual')}
                     checked={field.value}
                     onChange={field.onChange}
                     testId="script-manual"
                   />
                 )}
               />
               <Controller
                 name="script"
                control={control}
                rules={{ required: t('ScriptFileRequired') }}
                render={({ field }) => (
                  <SIMPLFile
                    errors={errors}
                    errorFieldName="script"
                     dragDropFileHereLabel={t('DragDropFileHereOrClickHere')}
                    chooseFileLabel={t('ChooseFile')}
                    currentScript={
                      field.value instanceof File ? field.value : null
                    }
                    onFileChange={field.onChange}
                    getRootProps={getRootProps}
                    getInputProps={getInputProps}
                    isDragActive={isDragActive}
                    LABELS={LABELS}
                    labelName={t('ScriptFile')}        
                    required
                    testId="script-file"
                  />
                )}
              />
              <Controller
                name="configFiles"
                control={control}
                render={({ field }) => (
                  <SIMPLFile
                    onFileChange={field.onChange}
                    dragDropFileHereLabel={t('DragDropFileHereOrClickHere')}
                    chooseFileLabel={t('ChooseFile')}
                    required={false}
                    errorFieldName="configFiles"
                    errors={errors}
                    currentScript={
                      field.value instanceof File ? field.value : null
                    }
                    LABELS={LABELS}
                    labelName={t('ConfigFiles')}
                    getRootProps={getConfigRootProps}
                    getInputProps={getConfigInputProps}
                    isDragActive={isConfigDragActive}
                     testId="script-config-file"
                   />
                 )}
               />
            </div>
          </div>
        </div>
      </LoadingWrapper>
    </SIMPLDialog>
  );
};
export default AddScript;